import React from "react";
import { Box, Button } from "@mui/material";
import ActionFooter from "../../../Shared/ActionFooter/ActionFooter";
import plateNotIdentified from "../../../../assets/images/inspection/plate-not-identified.png";

interface PlateErrorProps {
  /** Whether the error screen is visible. */
  open: boolean;
  /** Called when the user taps "Ok, entendi". */
  onClose: () => void;
}

const PlateError: React.FC<PlateErrorProps> = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <Box
      component="div"
      className="inspection"
      data-testid="plate-error"
      sx={{
        position: 'fixed',
        top: '56px',
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#FFFFFF',
        zIndex: (theme) => theme.zIndex.modal + 2,
        alignItems: 'center',
        justifyContent: 'flex-start',
      }}
    >
      <div className="title" style={{ textAlign: 'center', padding: '0 20px' }}>
        Não conseguimos identificar<br />o veículo
      </div>
      <div className="description">
        Verifique se a placa foi digitada corretamente e
        tente novamente no Painel de Vistorias.
      </div>
      <img
        src={plateNotIdentified}
        alt="placa-não-identificada"
        className="ilustration"
        data-testid="plate-error-image"
      />
      <ActionFooter>
        <Button
          fullWidth
          variant="contained"
          className="black-button"
          onClick={onClose}
          data-testid="plate-error-ok"
          sx={{ textTransform: 'none !important' }}
        >Ok, entendi</Button>
      </ActionFooter>
    </Box>
  );
};

export default PlateError;
